import store from '../store'

export default async (to, from, next) => {
  document.title = `${to.name} - Controle de Audiência`

  console.log("beforeEach", 'TO: ', to, 'FROM: ', from, 'NEXT: ', next)

  if (to.name !== 'login' && !store.getters['auth/hasToken']) {
    console.log("beforeEach", '!!!login ')

    try {
      await store.dispatch('auth/ActionCheckToken')
      await store.dispatch('units/ActionGetCurrentUnit')

      console.log("beforeEach", '!!!login NEXT path: to.path:', to.path)

      // vejo se tem o storage Ismember
      await store.dispatch('auth/ActionCheckIsMember')

      // se não for aluno
      if (!store.getters['auth/isMember']) {
        await store.dispatch('units/ActionGetCurrentUnit')
        next({
          name: 'home'
        })
      } else {

        next({
          name: 'member'
        })
      }


      // next({
      //   path: to.path
      // })

    } catch (err) {
      console.log("beforeEach", 'ERRO !!!login NEXT name: LOGIN')
      next({
        name: 'login'
      })
    }
  } else {
    console.log("beforeEach", 'ELSE ------', to.name)

    if (to.name === 'login' && store.getters['auth/hasToken']) {
      console.log("beforeEach", '====login')

      // vejo se tem o storage Ismember
      await store.dispatch('auth/ActionCheckIsMember')

      // se não for aluno
      if (!store.getters['auth/isMember']) {
        await store.dispatch('units/ActionGetCurrentUnit')
        next({
          name: 'home'
        })
      } else {

        next({
          name: 'member'
        })
      }
      console.log("beforeEach", 'ELSE ------ NEXT name:', name)

      next({
        name: 'home'
      })
    } else {
      console.log("beforeEach", 'ELSEE-- NEXT()')

      console.log('from:', from)
      console.log('next:', next)

      next()
    }
  }
}